import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import CommentSection from 'app/components/layouts/Comments/CommentSection';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import GoogleAdsense from 'app/components/layouts/Ads/GoogleAdsense';
import { withGlobalData } from 'app/utils/withGlobalData';
import { findTranslate } from 'app/utils/translate';
import Title from 'app/components/layouts/Title';
import Links from 'app/components/games/Links';
import listGame from "app/data/list_game.json";
import * as gameApi from 'app/requests/games';
import { useRouter } from "next/router";
import { NextSeo } from 'next-seo';

export default function GameEmbed({ gameProp }) {
  const router = useRouter();
  const slug = router.query.slug as string;
  const game = listGame.find(game => game.path == `${slug}`);

  return (
    <section className="box-card-area py-md-2 py-0">
      <NextSeo
        title={findTranslate(gameProp.translates, 'title', router?.locale)}
        description={findTranslate(gameProp.translates, 'describe', router?.locale)}
        additionalMetaTags={[{
          name: 'keywords',
          content: findTranslate(gameProp.translates, 'keywords', router?.locale)
        }]}
      />
      <div className="wrap-content">
        <div className="d-flex">
          <div className="box-news-area">
            <div className='content_inner'>
              <Title title={findTranslate(gameProp.translates, 'title', router?.locale)} />
              <div className="game-content mt-3">
                <iframe
                  style={{ maxWidth: '1000px', overflow: 'hidden', border: 'none' }}
                  src={`https://www.gamestolearnenglish.com/${game?.embed}`}
                  title={findTranslate(gameProp.translates, 'title', router?.locale)}
                  width='100%' height='580px'
                  allow="camera;microphone">
                </iframe>
              </div>
              <GoogleAdsense width="100%" dataSlot="7482232136" />
              <div className="p-2">
                <span dangerouslySetInnerHTML={{ __html: findTranslate(gameProp.translates, 'content', router?.locale) }} />
                <GoogleAdsense width="100%" dataSlot="7482232136" />
                <Links game={gameProp} />
              </div>
              <CommentSection roomId={`game-id-${gameProp?.id}`} />
            </div>
          </div>
          <RightContent />
        </div>
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale, query }) => {
  try {
    const [gameProp, translations] = await Promise.all([
      gameApi.getBySlug(query.slug, locale),
      serverSideTranslations(locale, ['common']),
    ]);

    return {
      props: {
        ...translations,
        gameProp,
      },
    };
  } catch (error) {
    console.error('Error in getServerSideProps:', error);
    return { notFound: true };
  }
});
